import { render, staticRenderFns } from "./SearchAddressWidget.vue?vue&type=template&id=23b92cb1&"
import script from "./SearchAddressWidget.vue?vue&type=script&lang=js&"
export * from "./SearchAddressWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports